import { createRoute, redirect } from '@tanstack/react-router'
import { managementLayoutRoute } from '@/ui/pages/management'
import { useAuthStore } from '@/application/stores/auth.store'
import { ImportSection } from './components/ImportSection'
import { ExportSection } from './components/ExportSection'

// eslint-disable-next-line react-refresh/only-export-components
export const importExportRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'import-export',
  beforeLoad: () => {
    const { user } = useAuthStore.getState()
    if (user?.role !== 'streamer' && user?.role !== 'admin') {
      throw redirect({ to: '/manage/dashboard' })
    }
  },
  component: ImportExportPage,
})

export function ImportExportPage() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ImportSection />
        <ExportSection />
      </div>
    </div>
  )
}
